/* eslint-disable react/prop-types */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-explicit-any */
import ClearIcon from '@mui/icons-material/Clear';
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Switch,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import classNames from 'classnames';
import { ref, onValue, remove } from 'firebase/database';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import ReactDatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Input } from 'reactstrap';
import useSessionStorageState from 'use-session-storage-state';

import {
  getMaterials,
  removeMaterialItem,
  getStudents,
  setStudentMaterial,
  subjectsObj,
  subscribeToMaterialsChanges,
  getStudentsGroup,
  setMaterialToGroup,
} from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Loader from '../../Components/Loader';
import Modal from '../../Components/ModalMaterial';
import NoItems from '../../Components/NoItems';
import Tooltipe from '../../Components/Tooltipe';
import { getUserType } from '../../redux/slices/userSlice';
import './style.scss';

const { SearchBar } = Search;

const defaultFilters = {
  page: 1,
  grade: '',
  subject: '',
  theme: '',
  teacherMath: false,
  type: '',
};

function getFiltersFromCookies() {
  return JSON.parse(sessionStorage.getItem('filters') ?? JSON.stringify(defaultFilters));
}

const Materials = ({ mail }) => {
  const [filters, setFiltersRaw] = useSessionStorageState('filters', {
    defaultValue: defaultFilters,
  });

  function setFiltersInCookies(newFilters) {
    const filters = getFiltersFromCookies();

    const endedFilters = { ...filters, ...(typeof newFilters === 'function' ? newFilters(filters) : newFilters) };

    sessionStorage.setItem('filters', JSON.stringify(endedFilters));
    setFiltersRaw(endedFilters);
  }

  const setFilters = setFiltersInCookies;

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const pagination = paginationFactory({
    sizePerPage: 8,
    hideSizePerPage: true,
    page: filters.page,
    onPageChange: page => setFilters({ page }),
  });

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [materials, setMaterials] = useState([]);

  const [materialsForView, setMaterialsForView] = useState([]);
  const searchRef = useRef(null);
  const userTypeSelector = useSelector(getUserType);

  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalUpdateOpen, setModalUpdateOpen] = useState(false);
  const [updateFormObj, setUpdateFormObj] = useState('');
  const [popupRemove, setPopupRemove] = useState(false);
  const [removeMaterial, setRemoveMaterial] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [popupSendMaterial, setPopupSendMaterial] = useState(false);
  const [currentMaterial, setCurrentMaterial] = useState('');
  const [listStudents, setListStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [itemStudent, setItemStudent] = useState('');
  const [noStudentsFound, setNoStudentsFound] = useState(false);
  const [popupSendInteractiveExam, setPopupSendInteractiveExam] = useState(false);
  const [deadline, setDeadline] = useState(tomorrow);
  const [listStudentsGroup, setListStudentsGroup] = useState([]);
  const [swichChecked, setSwichChecked] = useState(false);
  const [selectedStudentsGroup, setSelectedStudentsGroup] = useState();
  const [selectedGroupName, setSelectedGroupName] = useState();
  const [userType, setUserType] = useState(userTypeSelector);

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  const onClickRemoveItem = async () => {
    const refDb = ref(database, 'Students');

    onValue(refDb, snapshot => {
      Object.entries(snapshot.val()).forEach(([studentId, student]) => {
        if (student.materials && student.materials[removeMaterial.id]) {
          const refStudentMat = ref(database, `Students/${studentId}/materials/${removeMaterial.id}`);
          remove(refStudentMat);
        }
      });
    });

    await removeMaterialItem(removeMaterial.id, removeMaterial.thum, removeMaterial.url);
    toast.success(t('popupMaterialDeleted'));
    setPopupRemove(false);
  };

  const openModalFunc = title => {
    switch (title) {
      case 'add form':
        setModalAddOpen(true);
        break;
      case 'update form':
        setModalUpdateOpen(true);
        break;
    }
  };

  const columns = [
    { dataField: 'id', hidden: true },
    {
      dataField: 'name',
      text: t('title'),
      flex: 1,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'grade',
      text: t('class'),
      width: 130,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'subject',
      text: t('subject'),
      width: 130,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'theme',
      text: t('theme'),
      flex: 1,
      disableClickEventBubbling: true,
      formatter: cell => {
        return cell !== '' ? cell : '-';
      },
    },
    {
      dataField: 'type',
      text: t('type'),
      width: 30,
      disableClickEventBubbling: true,
      formatter: (_, row) => {
        if (row.type === 'Exam' && 'chapter' in row) {
          return t('interactive CL');
        } else if (row.type === 'Exam') {
          return t('Exam');
        } else if (row.type === 'Book') {
          return t('Book');
        } else if (row.type === 'Picture') {
          return t('Picture');
        }
      },
    },
    {
      dataField: 'lang',
      text: t('language'),
      width: 15,
      disableClickEventBubbling: true,
    },
    {
      dataField: 'id',
      headerStyle: {
        width: '100px',
      },
      text: <div className="sticky-wrap">{t('options')}</div>,
      formatter: () => (
        <div className="sticky-wrap actions-wrap">
          <div className="btn-wrap">
            <Tooltipe text="update" icon="icon-edit-1" btnClass="move-edit" />
            <Tooltipe text="delete" icon="icon-delete" btnClass="move-delete" />
            <Tooltipe text="send" icon="icon-envelope" btnClass="move-send" />
          </div>
        </div>
      ),
    },
  ];

  // const getSubjectOptions = () => {
  //   return [...new Set(materials.map((item) => item.subject))];
  // };

  const subjectOptions = useMemo(() => {
    return [...new Set(materials.map(item => item.subject))];
  }, [materials]);

  const subjectOptionsEng = useMemo(() => {
    return [
      ...new Set(
        materials.map(item => {
          if (item.subject === 'English') {
            return item.grade;
          }
        }),
      ),
    ];
  }, [materials]);

  const subjectOptionsNotEng = useMemo(() => {
    return [
      ...new Set(
        materials.map(item => {
          if (item.subject !== 'English') {
            return item.grade;
          }
        }),
      ),
    ];
  }, [materials]);

  const themeOptions = useMemo(() => {
    return [
      ...new Set(
        materials
          .filter(
            item =>
              (!filters.grade || item.grade === filters.grade) &&
              (!filters.subject || item.subject === filters.subject),
          )
          .map(item => item.theme),
      ),
    ];
  }, [materials, filters]);

  const typeOptions = useMemo(() => {
    return [
      ...new Set(
        materials
          .filter(
            item =>
              (!filters.grade || item.grade === filters.grade) &&
              (!filters.subject || item.subject === filters.subject),
          )
          .map(item => item.type),
      ),
    ];
  }, [materials, filters]);

  useEffect(() => {
    setMaterialsForView(
      materials.filter(
        material =>
          (!filters.theme || material.theme === filters.theme) &&
          (!filters.grade || material.grade === filters.grade) &&
          (!filters.subject || material.subject == filters.subject) &&
          (!filters.type || material.type === filters.type) &&
          (!filters.teacherMath || material.mail == mail.replace(/\./g, '')),
      ),
    );
  }, [filters, materials, mail]);

  const rowEvents = {
    onClick: (e, row) => {
      if (!e.target.closest('.btn-icon') && row.type === 'Exam' && 'chapter' in row) {
        navigate(`/checklist-view/${row.id}`, { state: row });
      } else if (!e.target.closest('.btn-icon')) {
        navigate('/materialView', { state: row });
      }

      if (e.target.closest('.btn-icon')) {
        switch (e.target.closest('.btn-icon').className) {
          case 'btn btn-icon move-delete':
            setPopupRemove(true);

            setRemoveMaterial({
              subject: row.subject,
              id: row.id,
              grade: row.grade,
              lang: row.lang,
              name: row.name,
              theme: row.theme,
              thum: row.thum,
              type: row.type,
              url: row.url,
              remove: 'remove',
            });

            break;

          case 'btn btn-icon move-edit':
            if (row.type === 'Exam' && 'chapter' in row) {
              navigate(`/checklist-edit/${row.id}`, { state: row });
            }

            if (row.type === 'Book' || row.type === 'Exam' || row.type === 'Picture') {
              openModalFunc('update form');
              setUpdateFormObj(row);
            }

            break;

          case 'btn btn-icon move-send':
            const updatedRow = {
              ...row,
              subject: row.subject === 'Англiйська мова' ? 'Англійська мова' : row.subject,
            };
            if (updatedRow.type === 'Exam' && 'chapter' in updatedRow) {
              setPopupSendInteractiveExam(true);
              setCurrentMaterial(updatedRow);
            } else {
              setPopupSendMaterial(true);
              setCurrentMaterial(updatedRow);
            }

            break;
        }
      }
    },
  };

  const feachStudentsGroup = async () => {
    await getStudentsGroup().then(data => {
      if (data) {
        const arrGroup = Object.values(data);

        const filteredGroups = arrGroup.filter(group => {
          const subjects = group.subjects;
          if (!admins) {
            if (group.subjects) {
              for (const subjectName in subjects) {
                const subject = subjects[subjectName];
                if (subject.attachedTeacher && subject.attachedTeacher.id === mail) {
                  return true;
                }
              }
            }
          } else {
            if (group.subjects) {
              for (const subjectName in subjects) {
                const subject = subjects[subjectName];
                if (subject.activeSub) {
                  return true;
                }
              }
            }
          }
        });

        setListStudentsGroup(filteredGroups);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    feachStudentsGroup();

    const fetchData = async () => {
      const materialList = await getMaterials();
      setMaterials(materialList);
      setIsLoading(false);
    };

    fetchData();

    try {
      const res = getStudents();
      res.then(resp => {
        const arrStudents = Object.values(resp);
        setListStudents(arrStudents);
      });
    } catch (error) {}
  }, []);

  useEffect(() => {
    // Подписываемся на изменения
    const unsubscribe = subscribeToMaterialsChanges(updatedMaterials => {
      setMaterials(updatedMaterials);
      setIsLoading(false);
    });

    // Отписываемся при размонтировании компонента
    return () => {
      unsubscribe();
    };
  }, [selectedStudent, selectedStudentsGroup, swichChecked]);

  const onStudentChange = e => {
    const selectedStudent = e.target.value;
    const filterData = listStudents.filter(item => {
      if (selectedStudent === item.FIO) {
        return item;
      }
    });
    setSelectedStudent(selectedStudent);
    setItemStudent(filterData[0]);
  };

  const onStudentGroupChange = e => {
    const selectedValue = e.target.value;
    const selectedGroup = listStudentsGroup.find(item => item.groupName === selectedValue);
    setSelectedStudentsGroup(selectedGroup);
    if (selectedGroup) {
      setSelectedGroupName(selectedGroup.groupName);
    }
  };

  const onSendMaterial = () => {
    setStudentMaterial(currentMaterial, itemStudent, deadline, mail);
    setPopupSendMaterial(false);
    setPopupSendInteractiveExam(false);
    toast.success(t('popupMaterial'));
  };

  const onSendMaterialStudentsGroup = () => {
    const groupMap = Object.values(selectedStudentsGroup.students);
    const studentsId = groupMap.map(itemId => {
      return itemId.email;
    });

    setMaterialToGroup(currentMaterial, studentsId, deadline, selectedStudentsGroup);
    setPopupSendMaterial(false);
    setPopupSendInteractiveExam(false);
    toast.success(t('popupMaterial'));
  };

  useEffect(() => {
    setUserType(userTypeSelector);
  }, [currentMaterial, userTypeSelector]);

  function locMaterialsItems(materialsForView) {
    return materialsForView.map(item => ({
      ...item,
      subject: item.subject,
      grade: item.grade,
    }));
  }

  const handleClearFilters = () => {
    setFilters(defaultFilters);
    setTimeout(() => {
      searchRef.current?.props.onSearch('');
    }, 0);
  };

  const handleChangeDeadline = date => {
    setDeadline(date);
  };

  const handleSwichChange = e => {
    setSwichChecked(e.target.checked);
  };

  function endAdornmentClearButton(value, onClick) {
    return (
      value && (
        <InputAdornment sx={{ marginRight: '10px' }} position="end">
          <IconButton onClick={onClick}>
            <ClearIcon></ClearIcon>
          </IconButton>
        </InputAdornment>
      )
    );
  }

  return materials ? (
    <>
      <ToolkitProvider
        key={i18n.language}
        keyField="id"
        data={locMaterialsItems(materialsForView)}
        columns={columns}
        search
      >
        {props => (
          <div className="materials-page container">
            <ul className="filters-list first-list">
              <li className="search-input">
                <SearchBar {...props.searchProps} srText="" placeholder={t('search')} ref={searchRef} />
              </li>

              <li className="teacher-math">
                <label>
                  <Input
                    type="checkbox"
                    checked={filters.teacherMath}
                    onChange={() =>
                      setFilters(of => ({
                        teacherMath: !of.teacherMath,
                      }))
                    }
                  />
                  <span>{t('teacher materials')}</span>
                </label>
              </li>

              <li>
                <Button className="btn clear-filter with-icon" onClick={() => openModalFunc('add form')}>
                  <span className="icon icon-plus"></span>
                  <span className="title">{t('addMaterial')}</span>
                </Button>
              </li>

              <li>
                <Button className="btn clear-filter" onClick={handleClearFilters}>
                  {t('clearFilter')}
                </Button>
              </li>
            </ul>

            <ul className="filters-list">
              <li>
                {materials && (
                  <>
                    <FormControl fullWidth>
                      <InputLabel id="subject-label">{t('subject')}</InputLabel>
                      <Select
                        key={i18n.language}
                        labelId="subject-label"
                        id="subject-select"
                        value={filters.subject}
                        label={t('subject')}
                        onChange={e =>
                          setFilters({
                            subject: e.target.value,
                          })
                        }
                        endAdornment={endAdornmentClearButton(filters.subject, () =>
                          setFilters({
                            subject: defaultFilters.subject,
                          }),
                        )}
                      >
                        {subjectOptions.map((subject, i) => {
                          return (
                            <MenuItem key={i} value={subject}>
                              {subject}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </>
                )}
              </li>

              {
                <>
                  {materials && (
                    <>
                      {filters.subject === 'English' && (
                        <li>
                          <FormControl fullWidth>
                            <InputLabel id="grade-label-en">{t('englishClass')}</InputLabel>
                            <Select
                              key={i18n.language}
                              labelId="grade-label-en"
                              id="grade-select"
                              className="grade-select"
                              value={filters.grade}
                              label={t('englishClass')}
                              endAdornment={endAdornmentClearButton(filters.grade, () =>
                                setFilters({
                                  grade: defaultFilters.grade,
                                }),
                              )}
                              onChange={e =>
                                setFilters({
                                  grade: e.target.value,
                                })
                              }
                            >
                              {subjectOptionsEng.map((grade, i) => {
                                return (
                                  <MenuItem key={i} value={grade}>
                                    {grade}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </li>
                      )}
                    </>
                  )}
                </>
              }

              {
                <>
                  {materials && (
                    <>
                      {filters.subject !== 'English' && (
                        <li>
                          <FormControl fullWidth>
                            <InputLabel id="grade-label">{t('class')}</InputLabel>
                            <Select
                              labelId="grade-label"
                              id="grade-select"
                              className="grade-select"
                              value={filters.grade}
                              label={t('class')}
                              onChange={e =>
                                setFilters({
                                  grade: e.target.value,
                                })
                              }
                              endAdornment={endAdornmentClearButton(filters.grade, () =>
                                setFilters({
                                  grade: defaultFilters.grade,
                                }),
                              )}
                            >
                              {subjectOptionsNotEng
                                .sort((a, b) =>
                                  a.localeCompare(b, undefined, {
                                    numeric: true,
                                  }),
                                )
                                .map((grade, i) => {
                                  return (
                                    <MenuItem key={i} value={grade}>
                                      {grade}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </li>
                      )}
                    </>
                  )}
                </>
              }
              {(filters.subject || filters.grade) && (
                <li>
                  <FormControl fullWidth>
                    <InputLabel id="en-theme-label">{t('theme')}</InputLabel>
                    <Select
                      labelId="en-theme-label"
                      id="en-theme-label"
                      className="en-theme-label"
                      value={filters.theme}
                      label={t('theme')}
                      onChange={e =>
                        setFilters({
                          theme: e.target.value,
                        })
                      }
                      endAdornment={endAdornmentClearButton(filters.theme, () =>
                        setFilters({
                          theme: defaultFilters.theme,
                        }),
                      )}
                    >
                      {themeOptions
                        .sort((a, b) => {
                          const isNumericA = !isNaN(parseInt(a));
                          const isNumericB = !isNaN(parseInt(b));

                          if (isNumericA && isNumericB) {
                            return parseInt(a) - parseInt(b);
                          } else if (isNumericA) {
                            return -1;
                          } else if (isNumericB) {
                            return 1;
                          } else {
                            return t(a).localeCompare(t(b));
                          }
                        })
                        .map((theme, i) => {
                          if (theme) {
                            return (
                              <MenuItem key={i} value={theme}>
                                {theme}
                              </MenuItem>
                            );
                          }
                        })}
                    </Select>
                  </FormControl>
                </li>
              )}
              {(filters.subject || filters.type) && (
                <li>
                  <FormControl fullWidth>
                    <InputLabel id="en-type-label">{t('type')}</InputLabel>
                    <Select
                      labelId="en-type-label"
                      id="en-type-label"
                      className="en-type-label"
                      value={filters.type}
                      label={t('type')}
                      onChange={e =>
                        setFilters({
                          type: e.target.value,
                        })
                      }
                      endAdornment={endAdornmentClearButton(filters.type, () =>
                        setFilters({
                          type: defaultFilters.type,
                        }),
                      )}
                    >
                      {typeOptions
                        .sort((a, b) => {
                          const isNumericA = !isNaN(parseInt(a));
                          const isNumericB = !isNaN(parseInt(b));

                          if (isNumericA && isNumericB) {
                            return parseInt(a) - parseInt(b);
                          } else if (isNumericA) {
                            return -1;
                          } else if (isNumericB) {
                            return 1;
                          } else {
                            return t(a).localeCompare(t(b));
                          }
                        })
                        .map((type, i) => {
                          if (type) {
                            return (
                              <MenuItem key={i} value={type}>
                                {t(type)}
                              </MenuItem>
                            );
                          }
                        })}
                    </Select>
                  </FormControl>
                </li>
              )}
            </ul>

            <hr />

            <div className="materials-table">
              {isLoading ? (
                <Loader progress={undefined} />
              ) : (
                <>
                  {materials ? (
                    <BootstrapTable
                      {...props.baseProps}
                      pagination={pagination}
                      rowEvents={rowEvents}
                      classes="table-materials"
                    />
                  ) : (
                    <NoItems titleNoItems={t('noMaterials')} />
                  )}
                </>
              )}
            </div>
            <div
              className={classNames('popup-remove', {
                active: popupRemove,
              })}
            >
              <div className="popup-remove-content">
                <h3>{t('questionRemove')}</h3>
                <div className="btn-wrap">
                  <button className="btn btn-primary more btn-active" onClick={() => onClickRemoveItem()}>
                    {t('yes')}
                  </button>
                  <button className="btn more btn-view" onClick={() => setPopupRemove(false)}>
                    {t('no')}
                  </button>
                </div>
              </div>
            </div>

            <div
              className={classNames('popup-send-homework', {
                active: popupSendMaterial,
              })}
            >
              {popupSendMaterial && (
                <div className="popup-send-homework-content">
                  <div className="modal-header">
                    <h3>{t('materialSubmissionForm')}</h3>
                    <button className="btn btn-icon" onClick={() => setPopupSendMaterial(false)}>
                      <span className="icon icon-plus"></span>
                    </button>
                  </div>

                  <div className="swich-wrap">
                    <Switch
                      checked={swichChecked}
                      onChange={handleSwichChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                    <span className="title">{swichChecked ? t('Group of students') : t('To one student')}</span>
                  </div>

                  <div className="wrap-select-send">
                    <FormControl fullWidth>
                      <InputLabel id="student-label">{swichChecked ? t('select group') : t('wrapStudent')}</InputLabel>
                      <Select
                        labelId="student-label"
                        id="student-hw-select"
                        value={swichChecked ? selectedGroupName : selectedStudent}
                        label={swichChecked ? t('select group') : t('wrapStudent')}
                        onChange={swichChecked ? onStudentGroupChange : onStudentChange}
                      >
                        {swichChecked
                          ? listStudentsGroup.length > 0 &&
                            listStudentsGroup
                              .sort((a, b) => a.groupName.localeCompare(b.groupName))
                              .map((item, i) => {
                                const englishSubject = subjectsObj[currentMaterial.subject] || currentMaterial.subject;
                                const subArr = Object.values(item.subjects);
                                if (!admins) {
                                  const options = subArr.map((itemSub, index) => {
                                    if (
                                      englishSubject === itemSub.name &&
                                      itemSub.attachedTeacher &&
                                      itemSub.attachedTeacher.id === mail
                                    ) {
                                      return (
                                        <MenuItem key={index} value={item.groupName}>
                                          {item.groupName}
                                        </MenuItem>
                                      );
                                    }
                                  });
                                  return options;
                                } else {
                                  const options = subArr.map((itemSub, index) => {
                                    if (englishSubject === itemSub.name && itemSub.attachedTeacher) {
                                      return (
                                        <MenuItem key={index} value={item.groupName}>
                                          {item.groupName}
                                        </MenuItem>
                                      );
                                    }
                                  });
                                  return options;
                                }
                              })
                          : listStudents.length > 0 &&
                            listStudents
                              .sort((a, b) => {
                                const aFIO = a.FIO ?? '';
                                const bFIO = b.FIO ?? '';
                                return aFIO.localeCompare(bFIO);
                              })
                              .map((item, i) => {
                                const subjectKey = subjectsObj?.[currentMaterial?.subject];
                                const subject = item.subjects && subjectKey ? item.subjects[subjectKey] : undefined;
                                const hasActiveSub = subject && subject.activeSub;
                                const isAttachedTeacherIdMatch =
                                  subject && subject.attachedTeacher && subject.attachedTeacher.id === mail;
                                const adminMaterial = subject && subject.activeSub && subject.attachedTeacher;

                                if (!admins) {
                                  if (hasActiveSub && isAttachedTeacherIdMatch) {
                                    return (
                                      <MenuItem key={i} value={item.FIO}>
                                        {item.FIO}
                                      </MenuItem>
                                    );
                                  }
                                } else {
                                  if (adminMaterial) {
                                    return (
                                      <MenuItem key={i} value={item.FIO}>
                                        {item.FIO}
                                      </MenuItem>
                                    );
                                  }
                                }
                              })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="button-send-row send-material">
                    <button
                      className="btn btn-primary more"
                      onClick={swichChecked ? onSendMaterialStudentsGroup : onSendMaterial}
                    >
                      <span>{t('send')}</span>
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div
              className={classNames('popup-send-homework send-exam', {
                active: popupSendInteractiveExam,
              })}
            >
              <div className="popup-send-homework-content">
                <div className="modal-header">
                  <h3>{t('materialSubmissionForm')}</h3>
                  <button className="btn btn-icon" onClick={() => setPopupSendInteractiveExam(false)}>
                    <span className="icon icon-plus"></span>
                  </button>
                </div>

                <div className="swich-wrap">
                  <Switch
                    checked={swichChecked}
                    onChange={handleSwichChange}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                  <span className="title">{swichChecked ? t('Group of students') : t('To one student')}</span>
                </div>

                {popupSendInteractiveExam && (
                  <FormControl fullWidth className="select-students">
                    {noStudentsFound ? (
                      <Typography variant="body1">{t('hw-students-not-found')}</Typography>
                    ) : (
                      <>
                        <InputLabel id="student-label">
                          {swichChecked ? t('select group') : t('wrapStudent')}
                        </InputLabel>
                        <Select
                          labelId="student-label"
                          id="student-hw-select"
                          value={swichChecked ? selectedGroupName : selectedStudent}
                          label={swichChecked ? t('select group') : t('wrapStudent')}
                          onChange={swichChecked ? onStudentGroupChange : onStudentChange}
                        >
                          {swichChecked
                            ? listStudentsGroup.length > 0 &&
                              listStudentsGroup
                                .sort((a, b) => a.groupName.localeCompare(b.groupName))
                                .map((item, i) => {
                                  const englishSubject =
                                    subjectsObj[currentMaterial.subject] || currentMaterial.subject;
                                  const subArr = Object.values(item.subjects);
                                  if (!admins) {
                                    const options = subArr.map((itemSub, index) => {
                                      if (
                                        englishSubject === itemSub.name &&
                                        itemSub.attachedTeacher &&
                                        itemSub.attachedTeacher.id === mail
                                      ) {
                                        return (
                                          <MenuItem key={index} value={item.groupName}>
                                            {item.groupName}
                                          </MenuItem>
                                        );
                                      }
                                    });
                                    return options;
                                  } else {
                                    const options = subArr.map((itemSub, index) => {
                                      if (englishSubject === itemSub.name && itemSub.attachedTeacher) {
                                        return (
                                          <MenuItem key={index} value={item.groupName}>
                                            {item.groupName}
                                          </MenuItem>
                                        );
                                      }
                                    });
                                    return options;
                                  }
                                })
                            : listStudents.length > 0 &&
                              listStudents
                                .sort((a, b) => a.FIO.localeCompare(b.FIO))
                                .map((item, i) => {
                                  const subject = item.subjects[subjectsObj[currentMaterial.subject]];
                                  const hasActiveSub = subject && subject.activeSub;
                                  const isAttachedTeacherIdMatch =
                                    subject && subject.attachedTeacher && subject.attachedTeacher.id === mail;
                                  const adminMaterial = subject && subject.activeSub && subject.attachedTeacher;
                                  if (!admins) {
                                    if (hasActiveSub && isAttachedTeacherIdMatch) {
                                      return (
                                        <MenuItem key={i} value={item.FIO}>
                                          {item.FIO}
                                        </MenuItem>
                                      );
                                    }
                                  } else {
                                    if (adminMaterial) {
                                      return (
                                        <MenuItem key={i} value={item.FIO}>
                                          {item.FIO}
                                        </MenuItem>
                                      );
                                    }
                                  }
                                })}
                        </Select>
                      </>
                    )}
                  </FormControl>
                )}

                <div className="wrap-select-send">
                  <div className="wrap-deadline-text">
                    <div className="wrap-picker">
                      <span className="text-name">{t('choose a deadline')}</span>
                      <ReactDatePicker
                        selected={deadline}
                        onChange={handleChangeDeadline}
                        dateFormat="dd.MM.yyyy"
                        minDate={tomorrow}
                      />
                    </div>
                  </div>
                </div>

                <div className="button-send-row send-material">
                  <button
                    className={classNames('btn btn-primary more', {
                      disabled: (swichChecked && !selectedGroupName) || (!swichChecked && !selectedStudent),
                    })}
                    onClick={swichChecked ? onSendMaterialStudentsGroup : onSendMaterial}
                  >
                    <span>{swichChecked ? t('send group') : t('send student')}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>

      {modalAddOpen && (
        <Modal
          open={modalAddOpen}
          setOpen={setModalAddOpen}
          title={t('addMaterial')}
          submit={t('add')}
          nameAction={'addForm'}
          updateFormObj={''}
          materials={materials}
          mail={mail}
        />
      )}

      {modalUpdateOpen && (
        <Modal
          open={modalUpdateOpen}
          setOpen={setModalUpdateOpen}
          title={t('updateMaterial')}
          submit={t('change')}
          nameAction="updateForm"
          updateFormObj={updateFormObj}
          materials={materials}
          mail={undefined}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default Materials;
